'use client';

import { c as _c } from "react/compiler-runtime";
import { deleteCookie } from 'cookies-next/client';
import dayjs from 'dayjs';
import _ from 'lodash';
import NextLink from 'next/link';
import { redirect, usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { Avatar, CruzIcon, Divider, LinkButton } from '@/components';
import { pages } from '@/settings';
import { useGlobalStore } from '@/store/provider';
type NavItemProps = {
  icon?: React.ReactNode;
  name: string;
  href: string;
  count?: number;
};
export function NavMy() {
  const $ = _c(87);
  const {
    user,
    setUser,
    setToast
  } = useGlobalStore(_temp);
  const pathname = usePathname();
  let t0;
  if ($[0] !== setToast || $[1] !== setUser) {
    t0 = function signOut() {
      setUser(null, null);
      deleteCookie("access_token");
      deleteCookie("refresh_token");
      setToast({
        type: "success",
        message: "Successfully signed out"
      });
      redirect("/");
    };
    $[0] = setToast;
    $[1] = setUser;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const signOut = t0;
  let t1;
  if ($[3] !== signOut || $[4] !== user) {
    t1 = () => {
      if (_.isEmpty(user)) {
        signOut();
      }
    };
    $[3] = signOut;
    $[4] = user;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== user) {
    t2 = [user];
    $[6] = user;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  useEffect(t1, t2);
  let t3;
  if ($[8] !== pathname) {
    t3 = t4 => {
      const {
        icon,
        name,
        href,
        count
      } = t4;
      const isActive = pathname === href;
      return <li key={href}><NextLink hrefLang="en" href={href} className="nav-item" aria-current={isActive ? "page" : undefined}><span className="flex items-center gap-1.5">{icon}{name}</span>{!_.isUndefined(count) && <><span className="sr-only">, count: </span><span className="nav-count">{count}</span></>}</NextLink></li>;
    };
    $[8] = pathname;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const renderNavItem = t3;
  if (_.isEmpty(user)) {
    return null;
  }
  let t4;
  if ($[10] !== user?.date_create || $[11] !== user?.email || $[12] !== user?.first_name || $[13] !== user?.last_name || $[14] !== user?.location || $[15] !== user?.photo_url) {
    t4 = () => <section className="relative mb-4 flex w-full flex-col items-center text-sm/6 not-italic" aria-labelledby="user-profile-heading"><NextLink hrefLang="en" href={pages.myProfile.href} aria-label="Update Profile"><Avatar className="size-24" photo_url={user?.photo_url} name={`${user?.first_name} ${user?.last_name}`} /></NextLink><h2 id="user-profile-heading" className="truncate pb-1! text-lg! font-semibold! dark:font-medium!">{_.isEmpty(user?.first_name) ? user?.email : `${user?.first_name} ${user?.last_name}`}</h2>{!_.isEmpty(user?.location) && <div className="truncate font-light">{user?.location?.city}, {user?.location?.state_abbr} {user?.location?.zip_code}</div>}<div className="truncate font-light">Joined {dayjs(user?.date_create).fromNow()}</div>{_.isEmpty(user?.location) && <div className="mt-4"><LinkButton variant="primary" className="rounded-full px-6" href={pages.myProfile.href} icon="edit" label="Update Profile" /></div>}</section>;
    $[10] = user?.date_create;
    $[11] = user?.email;
    $[12] = user?.first_name;
    $[13] = user?.last_name;
    $[14] = user?.location;
    $[15] = user?.photo_url;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  const renderMyInfo = t4;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t20;
  let t21;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[17] !== renderMyInfo || $[18] !== renderNavItem || $[19] !== user) {
    const {
      statistic
    } = user || {};
    t20 = "My Cruz Sidebar Navigation";
    if ($[37] !== renderMyInfo) {
      t21 = renderMyInfo();
      $[37] = renderMyInfo;
      $[38] = t21;
    } else {
      t21 = $[38];
    }
    t5 = "btn-group divide-y-0! py-1";
    t6 = "My Cruz";
    if ($[39] !== renderNavItem) {
      t7 = renderNavItem(pages.myCruz);
      $[39] = renderNavItem;
      $[40] = t7;
    } else {
      t7 = $[40];
    }
    if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <Divider className="py-1" />;
      $[41] = t8;
    } else {
      t8 = $[41];
    }
    t9 = renderNavItem({
      ...pages.mySavedVehicle,
      count: statistic?.saved_vehicle || 0
    });
    t10 = renderNavItem({
      ...pages.mySavedSearch,
      count: statistic?.saved_search || 0
    });
    t11 = renderNavItem({
      ...pages.myAskCruzAi,
      count: statistic?.ai_search_count || 0
    });
    t12 = renderNavItem({
      ...pages.myRecentlyViewed,
      count: statistic?.recently_viewed_count || 0
    });
    if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <Divider className="py-1" />;
      $[42] = t13;
    } else {
      t13 = $[42];
    }
    t14 = renderNavItem({
      ...pages.myInquiries,
      count: statistic?.inquiry_count || 0
    });
    if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = <Divider className="py-1" />;
      $[43] = t15;
    } else {
      t15 = $[43];
    }
    t16 = renderNavItem({
      ...pages.myVehicles,
      count: statistic?.vehicle?.all || 0
    });
    let t22;
    if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
      t22 = <CruzIcon.Plus className="mr-0.5" />;
      $[44] = t22;
    } else {
      t22 = $[44];
    }
    if ($[45] !== renderNavItem) {
      t17 = renderNavItem({
        ...pages.postVehicle,
        icon: t22
      });
      $[45] = renderNavItem;
      $[46] = t17;
    } else {
      t17 = $[46];
    }
    if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
      t18 = <Divider className="py-1" />;
      $[47] = t18;
    } else {
      t18 = $[47];
    }
    t19 = renderNavItem({
      ...pages.mySpotted,
      count: statistic?.spotted_count || 0
    });
    $[17] = renderMyInfo;
    $[18] = renderNavItem;
    $[19] = user;
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
    $[24] = t14;
    $[25] = t15;
    $[26] = t16;
    $[27] = t17;
    $[28] = t18;
    $[29] = t19;
    $[30] = t20;
    $[31] = t21;
    $[32] = t5;
    $[33] = t6;
    $[34] = t7;
    $[35] = t8;
    $[36] = t9;
  } else {
    t10 = $[20];
    t11 = $[21];
    t12 = $[22];
    t13 = $[23];
    t14 = $[24];
    t15 = $[25];
    t16 = $[26];
    t17 = $[27];
    t18 = $[28];
    t19 = $[29];
    t20 = $[30];
    t21 = $[31];
    t5 = $[32];
    t6 = $[33];
    t7 = $[34];
    t8 = $[35];
    t9 = $[36];
  }
  let t22;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <CruzIcon.Plus className="mr-0.5" />;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== renderNavItem) {
    t23 = renderNavItem({
      ...pages.postSpotted,
      icon: t22
    });
    $[49] = renderNavItem;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <Divider className="py-1" />;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  let t25;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <CruzIcon.NotificationOn className="mr-0.5" />;
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  let t26;
  if ($[53] !== renderNavItem) {
    t26 = renderNavItem({
      ...pages.myNotificationSettings,
      icon: t25
    });
    $[53] = renderNavItem;
    $[54] = t26;
  } else {
    t26 = $[54];
  }
  let t27;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <Divider className="py-1" />;
    $[55] = t27;
  } else {
    t27 = $[55];
  }
  let t28;
  let t29;
  if ($[56] !== renderNavItem) {
    t28 = renderNavItem(pages.myProfile);
    t29 = renderNavItem(pages.myPassword);
    $[56] = renderNavItem;
    $[57] = t28;
    $[58] = t29;
  } else {
    t28 = $[57];
    t29 = $[58];
  }
  let t30;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <span className="flex items-center gap-x-2"><CruzIcon.LogOut />Sign Out</span>;
    $[59] = t30;
  } else {
    t30 = $[59];
  }
  let t31;
  if ($[60] !== signOut) {
    t31 = <button type="button" className="nav-item rounded" onClick={signOut} aria-label="My Account">{t30}</button>;
    $[60] = signOut;
    $[61] = t31;
  } else {
    t31 = $[61];
  }
  let t32;
  if ($[62] !== t10 || $[63] !== t11 || $[64] !== t12 || $[65] !== t13 || $[66] !== t14 || $[67] !== t15 || $[68] !== t16 || $[69] !== t17 || $[70] !== t18 || $[71] !== t19 || $[72] !== t23 || $[73] !== t26 || $[74] !== t28 || $[75] !== t29 || $[76] !== t31 || $[77] !== t5 || $[78] !== t6 || $[79] !== t7 || $[80] !== t8 || $[81] !== t9) {
    t32 = <ul className={t5} aria-label={t6}>{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}{t18}{t19}{t23}{t24}{t26}{t27}{t28}{t29}{t31}</ul>;
    $[62] = t10;
    $[63] = t11;
    $[64] = t12;
    $[65] = t13;
    $[66] = t14;
    $[67] = t15;
    $[68] = t16;
    $[69] = t17;
    $[70] = t18;
    $[71] = t19;
    $[72] = t23;
    $[73] = t26;
    $[74] = t28;
    $[75] = t29;
    $[76] = t31;
    $[77] = t5;
    $[78] = t6;
    $[79] = t7;
    $[80] = t8;
    $[81] = t9;
    $[82] = t32;
  } else {
    t32 = $[82];
  }
  let t33;
  if ($[83] !== t20 || $[84] !== t21 || $[85] !== t32) {
    t33 = <nav aria-label={t20}>{t21}{t32}</nav>;
    $[83] = t20;
    $[84] = t21;
    $[85] = t32;
    $[86] = t33;
  } else {
    t33 = $[86];
  }
  return t33;
}
function _temp(state) {
  return state;
}